import React, { useEffect, useState } from "react";
import { adminTransactions } from "../../adminApi";
import { Loader2, ShoppingBag, Coins } from "lucide-react";

function fmt(d) {
  if (!d) return "-";
  return new Date(d).toLocaleString("es-DO");
}

export default function AdminTransactions() {
  const [tx, setTx] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setTx(await adminTransactions()); } finally { setLoading(false); }
    })();
  }, []);

  const total = tx.reduce((s, t) => s + (t.price || 0), 0);
  const credits = tx.reduce((s, t) => s + (t.credits || 0), 0);

  return (
    <div>
      <h2 className="text-2xl font-extrabold text-gray-900 mb-5">Transacciones</h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
          <div className="flex items-center gap-3">
            <ShoppingBag className="w-8 h-8 text-blue-500" />
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500">Compras totales</p>
              <p className="text-2xl font-extrabold">{tx.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
          <div className="flex items-center gap-3">
            <Coins className="w-8 h-8 text-amber-500" />
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500">Cr\u00e9ditos vendidos</p>
              <p className="text-2xl font-extrabold">{credits}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
          <div className="flex items-center gap-3">
            <span className="text-3xl font-extrabold text-emerald-600">RD$</span>
            <div>
              <p className="text-xs uppercase tracking-wider text-gray-500">Ingresos totales</p>
              <p className="text-2xl font-extrabold text-emerald-600">{total.toLocaleString("es-DO")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Fecha</th>
                <th className="px-4 py-3 text-left font-semibold">Usuario</th>
                <th className="px-4 py-3 text-left font-semibold">Paquete</th>
                <th className="px-4 py-3 text-left font-semibold">Créditos</th>
                <th className="px-4 py-3 text-left font-semibold">Precio</th>
                <th className="px-4 py-3 text-left font-semibold">Método</th>
                <th className="px-4 py-3 text-left font-semibold">Estado</th>
              </tr>
            </thead>
            <tbody>
              {loading && (<tr><td colSpan={7} className="text-center py-10"><Loader2 className="w-5 h-5 animate-spin inline" /></td></tr>)}
              {!loading && tx.length === 0 && (<tr><td colSpan={7} className="text-center py-10 text-gray-500">Sin transacciones.</td></tr>)}
              {tx.map((t) => (
                <tr key={t.id} className="border-t border-gray-100 hover:bg-blue-50/30">
                  <td className="px-4 py-3 text-xs">{fmt(t.created_at)}</td>
                  <td className="px-4 py-3">
                    <div className="font-semibold text-gray-900">{t.user_name}</div>
                    <div className="text-xs text-gray-500">{t.user_email}</div>
                  </td>
                  <td className="px-4 py-3 text-xs">{t.package_id}</td>
                  <td className="px-4 py-3 font-bold">{t.credits}</td>
                  <td className="px-4 py-3 font-bold text-emerald-700">RD${t.price}</td>
                  <td className="px-4 py-3 text-xs"><span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[10px] font-bold uppercase">{t.method}</span></td>
                  <td className="px-4 py-3 text-xs"><span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800 text-[10px] font-bold uppercase">{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
